var MediaService = /** @class */ (function () {
    function MediaService(api) {
        this.API = api;
    }
    MediaService.prototype.getFiles = function (scope) {
        var url = "/media/files/scope/".concat(scope);
        return this.API.get(url);
    };
    MediaService.prototype.getFile = function (fileId) {
        var url = "/media/files/".concat(fileId);
        return this.API.get(url);
    };
    MediaService.prototype.getFolders = function () {
        var url = '/media/folders';
        return this.API.get(url);
    };
    MediaService.prototype.deleteFile = function (fileId) {
        var url = "/media/files/".concat(fileId);
        return this.API.delete(url);
    };
    MediaService.prototype.uploadToS3 = function (url, file, mimeType) {
        return fetch(url, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': mimeType,
            },
        });
    };
    MediaService.prototype.saveFile = function (name, contentType, gfxData, folderId, scope) {
        var url = "/media/folders/".concat(folderId, "/files");
        return this.API.post(url, {
            name: name,
            mime_type: contentType,
            gfx_data: gfxData,
            scope: scope,
        });
    };
    return MediaService;
}());
export { MediaService };
